module.exports = __webpack_public_path__ + "static/humanoid-19258dd22864378083aa7f5b73ff435d.jpg";